import "../vars_spectrum-darkest.css";
import $cVYsD$vars_spectrumdarkest_cssmjs from "../vars_spectrum-darkest_css.mjs";
import "../vars_spectrum-global.css";
import $cVYsD$vars_spectrumglobal_cssmjs from "../vars_spectrum-global_css.mjs";
import "../vars_spectrum-large.css";
import $cVYsD$vars_spectrumlarge_cssmjs from "../vars_spectrum-large_css.mjs";
import "../vars_spectrum-lightest.css";
import $cVYsD$vars_spectrumlightest_cssmjs from "../vars_spectrum-lightest_css.mjs";
import "../vars_spectrum-medium.css";
import $cVYsD$vars_spectrummedium_cssmjs from "../vars_spectrum-medium_css.mjs";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />





let $72cfff5b68b9aeeb$export$f30cb9bc4f736419 = {
    global: ($parcel$interopDefault($cVYsD$vars_spectrumglobal_cssmjs)),
    light: (0, ($parcel$interopDefault($cVYsD$vars_spectrumlightest_cssmjs))),
    dark: (0, ($parcel$interopDefault($cVYsD$vars_spectrumdarkest_cssmjs))),
    medium: ($parcel$interopDefault($cVYsD$vars_spectrummedium_cssmjs)),
    large: ($parcel$interopDefault($cVYsD$vars_spectrumlarge_cssmjs))
};


export {$72cfff5b68b9aeeb$export$f30cb9bc4f736419 as lightTheme};
//# sourceMappingURL=lightTheme.mjs.map
